var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M15.7375 0.513281C15.0531 -0.171094 13.9469 -0.171094 13.2625 0.513281L12.3219 1.45078L15.3813 4.51016L16.3219 3.56953C17.0063 2.88516 17.0063 1.77891 16.3219 1.09453L15.7375 0.513281ZM6.3875 7.38828C6.19687 7.57891 6.05 7.81328 5.96562 8.07266L5.04063 10.8477C4.95 11.1164 5.02188 11.4133 5.22188 11.6164C5.42188 11.8195 5.71875 11.8883 5.99062 11.7977L8.76562 10.8727C9.02188 10.7883 9.25625 10.6414 9.45 10.4508L14.6781 5.21953L11.6156 2.15703L6.3875 7.38828ZM4 1.83516C2.34375 1.83516 1 3.17891 1 4.83516V12.8352C1 14.4914 2.34375 15.8352 4 15.8352H12C13.6562 15.8352 15 14.4914 15 12.8352V9.83516C15 9.28203 14.5531 8.83516 14 8.83516C13.4469 8.83516 13 9.28203 13 9.83516V12.8352C13 13.3883 12.5531 13.8352 12 13.8352H4C3.44688 13.8352 3 13.3883 3 12.8352V4.83516C3 4.28203 3.44688 3.83516 4 3.83516H7C7.55312 3.83516 8 3.38828 8 2.83516C8 2.28203 7.55312 1.83516 7 1.83516H4Z",
          fill: "#016BFF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }